
import { Cookies } from "react-cookie";

type COOKIE_KEY_TYPE = "TEMP_TOKEN" | "ACCESS_TOKEN" | "REFRESH_TOKEN";

const cookies = new Cookies();

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const setCookie = (name: COOKIE_KEY_TYPE, value: string, options?: any) => {
	return cookies.set(name, value, { ...options });
};

export const getCookie = (name: COOKIE_KEY_TYPE) => {
	return cookies.get(name);
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const removeCookie = (name: COOKIE_KEY_TYPE, options?: any) => {
	return cookies.remove(name, { ...options });
};